// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__6vkw6","labelWrapper":"styles_labelWrapper__PtXvX","label":"styles_label__ZMC54"};